import MojitoModules from 'mojito/modules';
import { useOutletContext } from 'applications/common/routing/outlet-context.js';
import MojitoPresentation from 'mojito/presentation';

const { FlexPane } = MojitoPresentation.Components;
const PrebuiltBetBuilderCoupon = MojitoModules.PrebuiltBetBuilderCoupon;

export default function PrebuiltBetBuilderLeague({ mojitoTools }) {
    const { config } = mojitoTools;
    const { onDataLoad, type } = useOutletContext();

    return (
        <FlexPane config={config.container}>
            <PrebuiltBetBuilderCoupon
                pbbbGroupId={type.preBuiltBetBuilders?.group}
                config={config.pbbbCoupon}
                onDataLoad={onDataLoad}
            />
        </FlexPane>
    );
}
